var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { height: "100%", "background-color": "#222" },
      attrs: { row: "", wrap: "", "justify-center": "" }
    },
    [
      _vm.category === "Logic"
        ? _c(
            "v-flex",
            [
              _c("logicPanel", {
                attrs: {
                  currentNode: _vm.currentNode,
                  editor: _vm.editor,
                  diagramData: _vm.diagramData
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "User"
        ? _c(
            "v-flex",
            [
              _c("userPanel", {
                attrs: { currentNode: _vm.currentNode, editor: _vm.editor }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "Chatbot"
        ? _c(
            "v-flex",
            [
              _c("chatbotPanel", {
                attrs: {
                  currentNode: _vm.currentNode,
                  editor: _vm.editor,
                  diagramData: _vm.diagramData
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc7bdc4c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc7bdc4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/bottomPanel.vue
// module id = null
// module chunks = 